import { render, staticRenderFns } from "./CustomPageList.vue?vue&type=template&id=04bf8f9c&scoped=true"
import script from "./CustomPageList.vue?vue&type=script&lang=js"
export * from "./CustomPageList.vue?vue&type=script&lang=js"
import style0 from "./CustomPageList.vue?vue&type=style&index=0&id=04bf8f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf8f9c",
  null
  
)

export default component.exports